module.exports = __webpack_public_path__ + "media/3_1-1.da0f1025.mp3";